import { useMemo } from "react";
import { getLayout, normalizeTheme } from "./index";
import { getSampleArticles } from "./sampleContent";
import type { TemplateRecord } from "@/lib/packageAccess";
import type { AdSlotsConfig } from "./types";

type Props = {
  template: TemplateRecord & {
    layout_key?: string | null;
    theme?: unknown;
  };
  ads?: AdSlotsConfig;
};

export default function TemplateRenderer({ template, ads }: Props) {
  const Layout = useMemo(() => getLayout(template.layout_key), [template.layout_key]);
  const theme = useMemo(() => normalizeTheme(template.theme), [template.theme]);
  const articles = useMemo(
    () => getSampleArticles(template.category ?? "actualites-generales", template.language),
    [template.category, template.language]
  );
  return (
    <Layout
      theme={theme}
      template={{ name: template.name, category: template.category ?? "actualites-generales" }}
      articles={articles}
      language={template.language}
      ads={ads}
    />
  );
}
